import { XCircle } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const problems = [
  {
    title: "Processos manuais e demorados",
    description:
      "Cada viagem exige conferência manual no Sistema Mercante — um trabalho repetitivo que consome dias e gera erros invisíveis.",
  },
  {
    title: "Erros que passam despercebidos",
    description:
      "Lançamentos incorretos, valores divergentes, prazos perdidos. Sem tecnologia, os erros se acumulam e ninguém percebe.",
  },
  {
    title: "Falta de visibilidade e controle",
    description:
      "Planilhas, e-mails e acompanhamento disperso. Nenhuma empresa deveria operar assim em um processo regulatório crítico.",
  },
  {
    title: "Travas burocráticas sem solução clara",
    description:
      "Quando o processo trava — e ele trava — a maioria das empresas não sabe a quem recorrer nem como destravar.",
  },
];

const Problem = () => {
  const sectionRef = useScrollReveal();

  return (
    <section
      id="o-problema"
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="py-24 relative overflow-hidden bg-dots"
      style={{ background: "var(--color-branco-vela)" }}
    >
      <div className="container mx-auto px-4 lg:px-6 relative">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16" data-animate>
          <div className="eyebrow justify-center">Pain Points</div>
          <h2
            className="heading-h2 mb-4"
            style={{ color: "var(--color-preto-marca)" }}
          >
            Por que tantas empresas perdem — ou deixam de ganhar — com o AFRMM?
          </h2>
          <div
            className="w-14 h-px mx-auto mb-6"
            style={{ background: "var(--color-cinza-nevoa)" }}
          />
          <p
            className="text-base font-light leading-relaxed"
            style={{ color: "var(--color-cinza-ancora)" }}
          >
            O processo de creditamento do AFRMM é burocrático, técnico e cheio
            de travas. A maioria das empresas enfrenta problemas que poderiam ser
            evitados.
          </p>
        </div>

        {/* Problem Cards */}
        <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto mb-12">
          {problems.map((problem, index) => (
            <div
              key={index}
              data-animate-from={index % 2 === 0 ? "left" : "right"}
              data-animate-delay={String(index + 1)}
              className="card-light p-7"
            >
              <div className="flex items-start gap-3">
                <XCircle
                  className="w-5 h-5 flex-shrink-0 mt-0.5"
                  style={{ color: "var(--color-cinza-ancora)", opacity: 0.6 }}
                />
                <div>
                  <h3
                    className="font-semibold text-[15px] mb-2"
                    style={{ color: "var(--color-preto-marca)" }}
                  >
                    {problem.title}
                  </h3>
                  <p
                    className="text-[14px] leading-relaxed font-light"
                    style={{ color: "var(--color-cinza-ancora)", lineHeight: 1.65 }}
                  >
                    {problem.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Transition text */}
        <p
          className="text-center italic text-base max-w-2xl mx-auto font-light"
          data-animate
          style={{ color: "var(--color-cinza-ancora)" }}
        >
          A boa notícia: existe uma forma mais inteligente — e a SIATECH
          construiu ela.
        </p>
      </div>
    </section>
  );
};

export default Problem;
